/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_LabelInputs */

const en_admin_external_booking_edit_order_summary_label = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order Summary`)
};

const de_admin_external_booking_edit_order_summary_label = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellübersicht`)
};

const es_admin_external_booking_edit_order_summary_label = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen del pedido`)
};

const fr_admin_external_booking_edit_order_summary_label = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récapitulatif`)
};

const nl_admin_external_booking_edit_order_summary_label = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellingsoverzicht`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */
const it_admin_external_booking_edit_order_summary_label = en_admin_external_booking_edit_order_summary_label;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_order_summary_label = en_admin_external_booking_edit_order_summary_label;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */
const pl_admin_external_booking_edit_order_summary_label = en_admin_external_booking_edit_order_summary_label;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */
const hu_admin_external_booking_edit_order_summary_label = en_admin_external_booking_edit_order_summary_label;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_LabelInputs) => LocalizedString} */
const ro_admin_external_booking_edit_order_summary_label = en_admin_external_booking_edit_order_summary_label;

/**
* | output |
* | --- |
* | "Order Summary" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_label = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_label(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_label(inputs)
	return ro_admin_external_booking_edit_order_summary_label(inputs)
});
export { admin_external_booking_edit_order_summary_label as "admin.external_booking_edit.order_summary.label" }